var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header",style:({
  ..._vm.props.backgroundImageURL && { background: `url(${_vm.props.backgroundImageURL}) no-repeat center center` }
})},[_c('div',{staticClass:"container"},[(_vm.props.title)?_c('h2',{staticClass:"title mb-0"},[_vm._v(_vm._s(_vm.props.title))]):_vm._e(),(_vm.props.subtitle)?_c('h5',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.props.subtitle))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }